module.exports = __webpack_public_path__ + "static/media/mapLocation.e4292f3b.JPG";